import { render, staticRenderFns } from "./boothMap.vue?vue&type=template&id=ae058cb6&scoped=true"
import script from "./boothMap.vue?vue&type=script&lang=js"
export * from "./boothMap.vue?vue&type=script&lang=js"
import style0 from "./boothMap.vue?vue&type=style&index=0&id=ae058cb6&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../../../../opt/deploy_node_modules/ailaworld/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ae058cb6",
  null
  
)

export default component.exports